<div class="search">
    <ng-container *ngIf="typeSearch == 'Employee'">
        <h6 class="mt-0 mb-2 text-white">
            <i class="fa-solid fa-magnifying-glass"></i>
            Busque su empleo acá
        </h6>
        <div class="form-group mb-3">
            <label class="text-white">Provincia</label>
            <div>
                <app-dropdown [options]="provinces" [(ngModel)]="filter.provinceId"></app-dropdown>
            </div>
        </div>
        <div class="form-group mb-3">
            <label class="text-white">Departamento</label>
            <div>
                <app-dropdown [options]="deparments" [(ngModel)]="filter.departmentId"></app-dropdown>
            </div>
        </div>
        <div class="form-group mb-3">
            <label class="text-white">Posición a desempeñar</label>
            <div>
                <app-dropdown [options]="positions" [(ngModel)]="filter.positionId"></app-dropdown>
            </div>
        </div>
        @if (withOutputData()) {
            <button class="btn btn-primary-theme w-100" (click)="submit()">
                <i class="fa-solid fa-magnifying-glass"></i>
                Buscar
            </button>
        }@else {
            <button class="btn btn-primary-theme w-100" (click)="redirectToSearch()">
                <i class="fa-solid fa-magnifying-glass"></i>
                Buscar
            </button>
        }
    </ng-container>
    <ng-container *ngIf="typeSearch == 'Shop'">
        <h6 class="mt-0 mb-2 text-white">
            <i class="fa-solid fa-magnifying-glass"></i>
            Herramientas para tu trabajo
        </h6>
        <div class="form-group mb-3">
            <label class="text-white">Provincia</label>
            <div>
                <select class="form-control">
                    <option value=""></option>
                    <option value="1" selected>Santo Domingo</option>
                    <option value="2">Provincia B</option>
                    <option value="3">Provincia C</option>
                </select>
            </div>
        </div>
        <div class="form-group mb-3">
            <label class="text-white">Categoria de productos</label>
            <div>
                <select class="form-control">
                    <option value=""></option>
                    <option value="1">Computadoras</option>
                    <option value="2">Mobiliario de Oficina</option>
                    <option value="3">Diseño grafico</option>
                    <option value="4">Articulos de papeleria</option>
                    <option value="5">Varios</option>
                </select>
            </div>
        </div>
        <div class="form-group mb-3">
            <label class="text-white">Producto que busca</label>
            <div>
                <input type="text" class="form-control" />
            </div>
        </div>
        <button class="btn btn-primary-theme w-100">
            <i class="fa-solid fa-magnifying-glass"></i>
            Buscar
        </button>
    </ng-container>
    <ng-container *ngIf="typeSearch == 'Beca'">
        <h6 class="mt-0 mb-2 text-white">
            <i class="fa-solid fa-magnifying-glass"></i>
            Como mejoramos hoy?
        </h6>
        <div class="form-group mb-3">
            <label class="text-white">Provincia</label>
            <div>
                <app-dropdown [options]="provinces" [(ngModel)]="filter.provinceId"></app-dropdown>
            </div>
        </div>
        <div class="form-group mb-3">
            <label class="text-white">Area de formación</label>
            <div>
                <select class="form-control">
                    <option value=""></option>
                    <option value="1">Contabilidad</option>
                    <option value="2">Finanzas</option>
                    <option value="3">Recursos Humanos</option>
                    <option value="4">Tecnologias de la información</option>
                    <option value="5">Cocina</option>
                    <option value="6">Despacho</option>
                    <option value="7">Mercadeo</option>
                    <option value="8">Bodega</option>
                </select>
            </div>
        </div>
        <div class="form-group mb-3">
            <label class="text-white">Curso que busca</label>
            <div>
                <input type="text" class="form-control" />
            </div>
        </div>
        <button class="btn btn-primary-theme w-100">
            <i class="fa-solid fa-magnifying-glass"></i>
            Buscar
        </button>
    </ng-container>
    <ng-container *ngIf="typeSearch == 'Freelancer'">
        <h6 class="mt-0 mb-2 text-white">
            <i class="fa-solid fa-magnifying-glass"></i>
            Busque su profesional acá
        </h6>
        <div class="form-group mb-3">
            <label class="text-white">Perfil Profesional</label>
            <div>
                <app-dropdown [options]="professionalProfiles" [(ngModel)]="filter.professionalProfileId"></app-dropdown>
            </div>
        </div>
        <div class="form-group mb-3">
            <label class="text-white">Provincia</label>
            <div>
                <app-dropdown [options]="provinces" [(ngModel)]="filter.provinceId"></app-dropdown>
            </div>
        </div>
        <div class="form-group mb-3">
            <label class="text-white">Departamento</label>
            <div>
                <app-dropdown [options]="deparments" [(ngModel)]="filter.departmentId"></app-dropdown>
            </div>
        </div>
        <button class="btn btn-primary-theme w-100" (click)="redirectToSearch()">
            <i class="fa-solid fa-magnifying-glass"></i>
            Buscar
        </button>
    </ng-container>
</div>